import Typography from '@mui/material/Typography';

import type { ErrorMessageProps } from './ErrorMessage.types';

const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return <Typography color="error">{message as string}</Typography>;
};
export default ErrorMessage;
